<template>
  <div class="body">
    <div class="mobile-background"></div>
    <video autoplay muted loop id="bg-video">
      <source src="../assets/Zecon Animação Push.mp4" type="video/mp4" />
      Seu navegador não suporta vídeos em HTML5.
    </video>
    <div class="home-content">
      <div class="left-content">
        <h1 class="title-intro">
          <span class="title-larger">ZECON</span><br />
          <span class="title-smaller">Bombas e Válvulas</span>
        </h1>

        <p class="text">
          Há mais de 20 anos no mercado, a Zecon demonstra seu potencial visando
          satisfazer seus clientes. Buscando sempre oferecer o melhor em
          equipamentos e serviços para sua empresa.
        </p>

        <a href="#contato">
          <button class="button-contato">CONTATE-NOS</button>
        </a>
      </div>

      <div class="right-content">
        <a :href="compliancePDF" target="_blank">
          <button class="button-compliance">
            <img src="../assets/iconpdf.svg" alt="Ícone" class="icon-pdf" />Compliance
          </button>
        </a>

        <div class="about">
          <h2 class="title-about">Missão</h2>
          <img src="../assets/iconseta.png" alt="Ícone" class="icon-seta" />
          <p class="text-about">
            “Crescimento contínuo e sustentável, oferecendo soluções eficazes no
            transporte de fluídos agressivos e seus serviços associados, sempre
            de forma ágil e transparente para superar as necessidades dos nossos
            clientes”.
          </p>
        </div>

        <div class="about">
          <h2 class="title-about">Visão</h2>
          <img src="../assets/iconseta.png" alt="Ícone" class="icon-seta" />
          <p class="text-about">
            “Ser referência nacional em fabricação e manutenção de Bombas e
            Válvulas, dobrando nossa participação nos próximos 2 anos nos
            segmentos, químico, petroquímico, fertilizantes e mineração,
            oferecendo equipamentos de ponta com diferencial na inovação
            tecnológica e na prestação de serviços, com preços competitivos e
            melhor atendimento aos anseios dos clientes.”
          </p>
        </div>

        <div class="about">
          <h2 class="title-about">Valores</h2>
          <img src="../assets/iconseta.png" alt="Ícone" class="icon-seta" />
          <p class="text-about">
            “Com competência, compromisso e atenção ao cliente, obstinação,
            tratamento igualitário, ética, eficiência operacional e inovação
            para reduzir custos, estaremos gerando valor aos nossos clientes e
            desenvolvendo oportunidades aos nossos colaboradores”.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Compliance from "../assets/Compliance.pdf";
export default {
  name: "Home",
  data() {
    return {
      compliancePDF: Compliance,
    };
  },
};
</script>

<style scoped>
.body {
  position: relative;
}

#bg-video {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  object-fit: cover;
}

.mobile-background {
  display: none;
}

.home-content {
  display: flex;
}

.left-content {
  display: flex;
  flex: 6;
  flex-direction: column;
  align-items: flex-start;
  margin: 28vh 0 14vh 6.4vw;
}

.right-content {
  display: flex;
  flex: 4;
  flex-direction: column;
  align-items: center;
  margin: 25vh 6.4vw 18vh 0;
}

.title-intro {
  color: #f5f5f5;
  font-family: "Montserrat", sans-serif;
  text-align: center;
  line-height: 1;
  text-shadow: 2px 2px 2px #000000a3;
}

.title-larger {
  font-size: 1.7em;
  font-weight: 400;
}

.title-smaller {
  font-size: 1.6em;
  font-weight: 300;
}

.text {
  color: #f5f5f5;
  font-family: "Montserrat", sans-serif;
  font-size: 1.5em;
  font-weight: 500;
  text-align: left;
  margin: 8vh 0;
  line-height: 1.35;
  width: 600px;
  text-shadow: 2px 2px 1px #00000000;
}

.button-contato {
  color: #16181a;
  background-color: #ffc737;
  font-family: "Montserrat", sans-serif;
  font-size: 1.7em;
  font-weight: 400;
  text-align: center;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  display: inline-block;
  padding: 0.3em 1.1em;
  box-shadow: 4px 4px 6px #00000080;
}

.button-compliance {
  color: #16181a;
  background-color: #ffc737;
  font-family: "Montserrat", sans-serif;
  font-size: 1.2em;
  font-weight: 400;
  text-align: center;
  border-radius: 4.5px;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.6em 1em;
  box-shadow: 2.9px 2.9px 4.3px #00000080;
}

.icon-pdf {
  width: 0.9em;
  height: 1.2em;
  margin-left: 0.4em;
  order: 1;
}

.about {
  display: flex;
  align-items: center;
  justify-content: center;
  text-shadow: 2px 2px 2px #000000a3;
  position: relative;
  transition: opacity 0.3s ease-in-out;
  margin-top: 12vh;
}

.title-about {
  color: #f5f5f5;
  font-family: "Montserrat", sans-serif;
  font-size: 2.9em;
  font-weight: 400;
  margin: 0;
  cursor: pointer;
  position: relative;
  transition: opacity 0.3s ease-in-out;
  z-index: 1;
}

.title-about::after {
  content: "";
  display: block;
  width: 2em;
  height: 0.09em;
  background-color: #ffc737;
  border-radius: 30px;
  position: absolute;
  top: 1.2em;
  left: 50%;
  transform: translateX(-50%);
  transition: opacity 0.3s ease-in-out;
  z-index: 1;
}

.icon-seta {
  width: 1.4em;
  height: 1.6em;
  margin-left: 0.5em;
  order: 1;
  transition: opacity 0.3s ease-in-out;
  z-index: 1;
}

.text-about {
  color: #f5f5f5;
  font-family: "Montserrat", sans-serif;
  font-size: 1.25em;
  font-weight: 300;
  text-align: center;
  width: 25em;
  line-height: 1;
  text-shadow: 2px 2px 2px #000000cc;
  opacity: 0;
  z-index: 2;
  position: absolute;
}

.about:hover .title-about::after,
.about:hover .title-about,
.about:hover .icon-seta {
  opacity: 0;
}

.about:hover .text-about {
  opacity: 1;
}

@media screen and (max-width: 1278px) {
  .left-content {
    margin: 25vh 0 14vh 6.4vw;
  }

  .right-content {
    margin: 22vh 6.4vw 18vh 0;
  }

  .title-larger {
    font-size: 1.6em;
  }

  .title-smaller {
    font-size: 1.4em;
  }

  .text {
    font-size: 1.3em;
    width: 550px;
  }

  .text-about {
    font-size: 1.1em;
    width: 20em;
  }
}

@media screen and (max-width: 992px) {
  .body {
    background-position: center;
  }

  .body::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #1a1a1a;
    z-index: -2;
  }

  #bg-video {
    display: none;
  }

  .mobile-background {
    display: block;
    position: fixed;
    z-index: -1;
    background: url('../assets/BackgroundHome.jpg') center/contain no-repeat fixed;
    width: 180%;
    height: 100%;
    top: 50%;
    left: 55%;
    transform: translate(-50%, -50%);
    object-fit: cover;
    z-index: -1;
  }

  .home-content {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .left-content {
    align-items: center;
    margin-bottom: 0;
    margin-left: 0;
  }

  .right-content {
    margin-top: 20vh;
    margin-right: 0;
  }

  .title-larger {
    font-size: 1.7em;
  }

  .title-smaller {
    font-size: 1.6em;
  }

  .text {
    font-size: 1.4em;
    width: 80%;
  }

  .text-about {
    font-size: 1.25em;
    width: 30em;
  }
}

@media (max-width: 593px) {
  .home-content {
    flex-direction: column;
    align-items: center;
  }

  .left-content {
    align-items: center;
    margin: 28vh 0 0 0;
  }

  .right-content {
    margin-top: 20vh 0 0 0;
  }

  .text {
    font-size: 1.3em;
    width: 80%;
  }

  .title-about {
    font-size: 2.5em;
  }

  .text-about {
    font-size: 1.1em;
    width: 20em;
  }
}
</style>